import { createContext, useContext, useState } from "react";

export const PAISES_UI = [
  { code: "CL", nombre: "Chile", moneda: "CLP", registro: "Registro Civil" },
  { code: "EC", nombre: "Ecuador", moneda: "USD", registro: "ANT" },
];

export const PAIS_CODES = PAISES_UI.map((p) => p.code);

const CountryContext = createContext({ pais: "CL", setPais: () => {}, paisUI: PAISES_UI[0] });

export const CountryProvider = ({ children }) => {
  const [pais, setPaisState] = useState(() => {
    try {
      const v = localStorage.getItem("tf_pais");
      return PAIS_CODES.includes(v) ? v : "CL";
    } catch { return "CL"; }
  });
  const setPais = (code, persist = true) => {
    setPaisState(code);
    if (persist) {
      try { localStorage.setItem("tf_pais", code); } catch { /* ignore */ }
    }
  };
  const paisUI = PAISES_UI.find((p) => p.code === pais) || PAISES_UI[0];
  return <CountryContext.Provider value={{ pais, setPais, paisUI }}>{children}</CountryContext.Provider>;
};

export const useCountry = () => useContext(CountryContext);
